import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-turns-form-gps-card',
  templateUrl: './turns-form-gps-card.component.html',
  styleUrls: ['./turns-form-gps-card.component.scss']
})
export class TurnsFormGpsCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormBasic;

  gpsForm = new FormGroup({
    latitude: new FormControl(0),
    longitude: new FormControl(0),
    distanceInMeters: new FormControl(0)
  });

  updateFormTurnsGeoLocationSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  private resetForm() {
    this.gpsForm.patchValue({
      latitude: this.form.Latitude,
      longitude: this.form.Longitude,
      distanceInMeters: this.form.DistanceInMeters
    });
  }

  public submitForm() {
    this.updateFormTurnsGeoLocationSubscription = this.formsTurnsService.updateFormTurnsGeoLocation(this.form.InternalId, this.gpsForm.get('latitude').value, this.gpsForm.get('longitude').value, this.gpsForm.get('distanceInMeters').value).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.updateFormTurnsGeoLocationSubscription) { this.updateFormTurnsGeoLocationSubscription.unsubscribe(); }
  }
}
